<template>
  <div class="audit_detail">
    <header></header>
    <main>
      <div class="content">
        <div class="containt">
          <ul class="ul" v-if="infor">
            <li class="li">
              <span>小区</span>
              <span class="adress">{{ infor.projectName }}</span>
            </li>
            <li class="li">
              <span>房屋</span>
              <span class="adress">{{ infor.roomName }}</span>
            </li>
            <li class="li">
              <span>身份</span>
              <span class="adress">{{ infor.identity }}</span>
            </li>
            <li class="li">
              <span>姓名</span>
              <span class="adress">{{ infor.customerName }}</span>
            </li>
            <li class="li">
              <span>联系电话</span>
              <span class="adress">{{ infor.contractPhone }}</span>
            </li>
            <li class="li">
              <span>证件类型</span>
              <span class="adress">{{ infor.idTypeDesc }}</span>
            </li>
            <li class="li">
              <span>证件号</span>
              <span class="adress">{{ infor.idNumber }}</span>
            </li>
            <li class="li">
              <span>补充说明</span>
            </li>
          </ul>
          <p>
            {{ infor.remark }}
          </p>
          <div class="pic" v-if="infor.imgs && infor.imgs.length">
            <van-image
              v-for="(item, index) in infor.imgs"
              :key="index"
              width="100"
              height="100"
              :src="item"
              @click="handleImg(item)"
            />
          </div>
        </div>
      </div>
    </main>
    <footer>
      <div>
        <span @click="pass">通过</span>
        <span @click="handleReject">拒绝</span>
      </div>
    </footer>
    <!-- 通过弹框 -->
    <div class="pass" v-if="infor.recommend">
      <van-popup v-model="showPass">
        <div class="wrap">
          <div class="bg"></div>
          <div class="containt">
            <ul class="ul">
              <li class="li">
                <span>客户姓名</span>
                <span class="adress">{{ infor.recommend.presentee }}</span>
              </li>
              <li class="li">
                <span>性别</span>
                <span class="adress">{{
                  infor.recommend.gender === 0 ? "男" : "女"
                }}</span>
              </li>
              <li class="li">
                <span>联系电话</span>
                <span class="adress">{{ infor.recommend.contactNumber }}</span>
              </li>
              <li class="li">
                <span>推荐城市</span>
                <span class="adress">{{ infor.recommend.orgName }}</span>
              </li>
              <li class="li">
                <span>推荐项目</span>
                <span class="adress">{{ infor.recommend.projectName }}</span>
              </li>
              <li>
                <div class="choice_consultant">
                  <div @click="showPopup" class="consultant">
                    <span>置业顾问</span>
                    <span class="choice"
                      >{{ name }}&nbsp;&nbsp;<van-icon name="arrow" class="ico"
                    /></span>
                  </div>
                </div>
              </li>
            </ul>
            <div class="share">
              <div @click="distribution(infor.id)">
                分配
              </div>
              <div @click="cancle">
                取消
              </div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>

    <!-- 置业顾问 -->
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '40%', width: '100%', overflowY: 'auto' }"
      round
    >
      <div class="header">
        <span @click="conCancle">取消</span>
        <span>选择置业顾问</span>
        <span @click="handleChoice">确定</span>
      </div>

      <van-row>
        <van-col
          class="managerName"
          span="7"
          :class="{ ch: categoryIndex === index }"
          v-for="(item, index) in conInfor"
          :key="item.managerCode"
          @click="choiceConsultant(item, index)"
        >
          {{ item.managerName }}</van-col
        >
      </van-row>
    </van-popup>

    <!-- 拒绝弹框 -->
    <div class="reject">
      <van-popup v-model="reject">
        <div class="content">
          <div class="head">
            审核失败
          </div>
          <div class="form">
            <van-form validate-first @submit="rejectConfirm">
              <van-field
                v-model="message"
                rows="2"
                autosize
                label="拒绝理由"
                required
                type="textarea"
                maxlength="150"
                placeholder="请输入拒绝理由"
                show-word-limit
              />
              <button>确认</button>
            </van-form>
          </div>
        </div>
      </van-popup>
    </div>
    <!-- loading -->
    <loading :show="loadingStatus"></loading>
  </div>
</template>

<script>
import loading from "@/components/loading";
import {
  Image as VanImage,
  Toast,
  Form,
  Field,
  Popup,
  Icon,
  Col,
  Row,
  ImagePreview,
} from "vant";

export default {
  data() {
    return {
      showPass: false,
      reject: false,
      consultant: "",
      message: "",
      infor: "",
      adviserName: "",
      show: false,
      conInfor: [],
      categoryIndex: "",
      name: "请选择置业顾问",
      personData: "",
      isLoading: false,
      loadingStatus: false,
    };
  },
  components: {
    "van-image": VanImage,
    "van-popup": Popup,
    "van-form": Form,
    "van-field": Field,

    "van-icon": Icon,
    "van-row": Row,
    "van-col": Col,
    loading,
  },
  created() {
    //app返回

    // this.$jsBridge.callHandler("dispatchBackBtn");
    // this.$jsBridge.registerhandler("onBackPressed", () => {
    //   this.goBack();
    // });
    this.$api
      .venture({
        id: this.$route.query.id,
      })
      .then((res) => {
        this.infor = res.body;
        this.name = this.infor.recommend.adviserName;
        this.adviserName = this.infor.recommend.adviserName;
      });
  },
  beforeRouteLeave(to, from, next) {
    localStorage.setItem("pageFrom", "/auditDetail");
    next();
  },
  methods: {
    //图片预览
    handleImg(e) {
      ImagePreview([e]);
    },
    //弹出置业顾问弹框
    showPopup() {
      if (!this.adviserName) {
        this.show = true;
        this.$api
          .advi({ projectCode: this.$route.query.projectCode })
          .then((res) => {
            this.conInfor = res.body;
          });
      }
    },
    //取消弹框
    conCancle() {
      this.show = false;
    },

    //置业顾问确定按钮
    handleChoice() {
      this.show = false;

      if (this.personData !== "") {
        this.name = this.personData.managerName;
        this.consultant = this.personData;
      }
    },
    //选择置业顾问
    choiceConsultant(v, index) {
      this.name = this.adviserName ? this.adviserName : "请选择置业顾问";
      this.categoryIndex = index;
      this.personData = v;
    },
    //返回列表页
    goBack() {
      this.$router.push({
        name: "OldNew",
        params: {
          from: "detail",
          projectCode: this.$route.query.projectCode,
        },
      });
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator(val) {
      return val !== "" ? true : false;
    },

    //通过
    pass() {
      this.showPass = true;
    },
    //拒绝
    handleReject() {
      this.reject = true;
    },
    //拒绝确认
    rejectConfirm() {
      if (!this.message) {
        Toast.fail("请填写拒绝理由");
        return false;
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.loadingStatus = true;

      this.$api
        .appealAudit({
          id: this.infor.id, //审核记录id
          status: 2, //1-通过 2-不通过
          reason: this.message, //原因
          projectType: 1, // 0-非合资项目 1-合资项目
        })
        .then(() => {
          Toast.success("提交成功");
          this.isLoading = false;
          this.loadingStatus = false;

          this.$router.back();
        })
        .catch((res) => {
          this.isLoading = false;
          this.loadingStatus = false;

          Toast(res);
        });
    },
    //取消
    cancle() {
      this.showPass = false;
      if (this.consultant) {
        this.name = "请选择置业顾问";
        this.consultant = "";
      }
    },
    //获取置业顾问信息
    getCode(v) {
      this.consultant = v;
    },
    //分配
    distribution(id) {
      //已分配置业顾问
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      if (this.infor.recommend.adviserName) {
        //通过审核
        this.loadingStatus = true;
        this.$api
          .appealAudit({
            id, //审核记录id

            status: 1, //1-通过 2-不通过
            reason: "", //原因
            projectType: 1, // 0-非合资项目 1-合资项目
            adviser: {
              adviserName: this.infor.recommend.adviserName,
              adviserCode: this.infor.recommend.adviserCode,
              adviserId: this.infor.recommend.adviserId,
            },
          })
          .then((res) => {
            Toast.success(res.message);
            this.$router.go(-1);
            this.loadingStatus = false;
            this.isLoading = false;
          })
          .catch((res) => {
            Toast({
              message: res,
              duration: 3500,
            });
            this.isLoading = false;
            this.loadingStatus = false;
          });

        this.consultant = "";
      } else {
        //未分配置业顾问
        if (this.consultant) {
          this.loadingStatus = true;
          //通过审核
          this.$api
            .appealAudit({
              id, //审核记录id

              status: 1, //1-通过 2-不通过
              reason: "", //原因
              projectType: 1, // 0-非合资项目 1-合资项目
              adviser: {
                adviserName: this.consultant.managerName,
                adviserCode: this.consultant.managerCode,
                adviserId: this.consultant.id,
              },
            })
            .then((res) => {
              Toast.success(res.message);
              this.isLoading = false;
              this.$router.go(-1);
              this.loadingStatus = false;
            })
            .catch((res) => {
              Toast(res);
              this.isLoading = false;
              this.loadingStatus = false;
            });
        } else {
          Toast.fail("请选择置业顾问");
          this.isLoading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.audit_detail {
  background: #f7f7f7;
  header {
    background: url("../../common/images/bc1.png");
    background-size: 100% 100%;
    height: 248px;
  }
  main {
    padding: 0 30px;
    margin-top: -200px;
    .content {
      height: 1100px;
      background: #ffffff;
      box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 16px;
      padding: 20px;
      .containt {
        width: 100%;
        .ul {
          width: 100%;
          .li {
            width: 100%;
            display: flex;
            justify-content: space-between;
            height: 100px;
            border-bottom: 1px solid rgba(244, 245, 245, 1);
            line-height: 100px;
            font-family: PingFangSC-Regular, PingFang SC;
            &:nth-last-child(1) {
              border: none;
            }
            span {
              color: #666666;
            }
            .adress {
              color: #333333;
            }
          }
        }
        p {
          margin-bottom: 30px;
        }
        .pic {
          display: flex;
          overflow-x: auto;
          .van-image {
            flex: none;
            margin-right: 20px;
          }
        }
      }
    }
  }
  footer {
    padding: 0 80px;
    margin-top: 40px;
    div {
      display: inline-flex;
      justify-content: space-between;
      width: 100%;
      span {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;

        font-weight: 500;
        width: 260px;
        height: 100px;
        background: url("../../common/images/tongguo.png");
        background-size: 100% 100%;
        &:nth-child(2) {
          background: url("../../common/images/jujue.png");
          background-size: 100% 100%;
        }
      }
    }
  }
  .pass {
    .van-popup {
      border-radius: 16px;
    }
    .wrap {
      width: 650px;
      height: 904px;
      background: #ffffff;
      padding: 32px 40px;
      .bg {
        width: 568px;
        height: 90px;
        background: url("../../common/images/tuijianbg.png");
        background-size: 100% 100%;
      }
      .containt {
        width: 100%;
        .ul {
          width: 100%;
          .li {
            width: 100%;
            display: flex;
            justify-content: space-between;
            height: 100px;
            border-bottom: 1px solid rgba(244, 245, 245, 1);
            line-height: 100px;
            span {
              color: #666666;
              font-size: 28px;
            }

            .adress {
              color: #333333;
            }
          }
        }
        .share {
          margin-top: 50px;
          display: flex;
          justify-content: space-between;

          div {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
            font-size: 32px;
            width: 270px;
            height: 84px;
            background: #0d9869;
            border-radius: 46px;
            &:nth-child(2) {
              background-color: #dedede;
            }
          }
        }
      }
    }
  }
  .reject {
    .van-popup {
      border-radius: 16px;
    }
    .van-cell {
      display: flex;
      flex-direction: column;
      &::after {
        border: none;
      }
      /deep/ .van-field__value {
        border: 1px solid #f2f2f2;
        margin-top: 20px;
        padding: 10px 20px;
      }
    }
    .content {
      width: 650px;
      height: 680px;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;
      padding: 60px 0;
    }
    button {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 32px;
      border: none;
      width: 570px;
      height: 88px;
      background: #0d9869;
      border-radius: 46px;
    }
    .head {
      width: 100%;
      padding: 30px 50px;

      font-size: 44px;

      font-weight: 500;
      color: #333333;
    }
    .form {
      flex: 1;
      .van-form {
        height: 100%;
        display: inline-flex;
        flex-direction: column;
        justify-content: space-around;
        /deep/ .van-field__control {
          height: 148px !important;
        }
      }
    }
  }
  /deep/.choice_consultant {
    .consultant {
      span {
        color: #666666;
      }
    }
  }
  .choice_consultant {
    width: 100%;
    .consultant {
      width: 100%;
      display: flex;
      justify-content: space-between;
      height: 100px;
      border-bottom: 1px solid rgba(244, 245, 245, 1);
      align-items: center;
      font-family: PingFangSC-Regular, PingFang SC;
      .choice {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        .ico {
          display: inline-block;
        }
      }
    }
  }
  .header {
    position: sticky;
    top: 0px;
    display: flex;
    padding: 30px 23px 15px 23px;
    justify-content: space-between;
    background-color: #fff;
    span {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      &:nth-child(1) {
        color: rgba(153, 153, 153, 1);
      }
      &:nth-child(2) {
        font-size: 36px;
        color: #333333;
      }
      &:nth-child(3) {
        color: rgba(153, 153, 153, 1);
        color: #0d9869;
      }
    }
  }
  .managerName {
    height: 88px;

    background-color: #f3f3f3;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 0 15px 20px 15px;

    color: rgba(87, 87, 87, 1);
    border-radius: 6px;
  }
  .people {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    padding: 26px 20px 36px 0;
    li {
      height: 88px;
      width: 30%;
      background-color: #f3f3f3;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 30px;
      margin-left: 23px;
      color: rgba(87, 87, 87, 1);
      border-radius: 6px;
    }
  }
  .ch {
    color: #fff !important;
    background-color: #0d9869 !important;
  }
}
</style>
